import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../core/service/auth.service';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      const session_state = params['session_state'];
      const ip_address = '127.0.0.1';
      const machine_name = 'MyMachine';

      if (code) {
        this.authService
          .microsoftAuthCallback({
            code,
            session_state,
            ip_address,
            machine_name,
          })
          .subscribe({
            next: (res) => {
              if (res?.data?.token) {
                this.router.navigate(['/dashboard']);
              } else {
                this.router.navigate(['/sign-in']);
              }
            },
            error: () => {
              console.error('Authentication error');
              this.router.navigate(['/sign-in']);
            },
          });
      } else {
        this.router.navigate(['/sign-in']);
      }
    });
  }
}
